"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBTextLink", {
  enumerable: true,
  get: function get() {
    return _SVBTextLink.default;
  }
});
var _SVBTextLink = _interopRequireDefault(require("./src/SVBTextLink"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }